/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


export default
{
  IncreaseInfluence: 0,
  IncreaseResistance: 1,
  RedirectInfluence: 2,
  ProjectPlatform: 3,
  FutureTarget: 4,

  DisableNeighbors: 5,
};
